import api from './client';

export const salesApi = {
  list:           (params?: any) => api.get('/sales', { params }),
  quickSale:      (data: any)    => api.post('/sales/quick', data),
  invoiceSale:    (data: any)    => api.post('/sales/invoice', data),
  receivePayment: (data: any)    => api.post('/sales/payment', data),
  listCustomerPayments: ()                   => api.get('/contact-payments'),
  updateCustomerPayment: (id: number, data: any) => api.put(`/contact-payments/${id}`, data),
  voidCustomerPayment:  (id: number, reason?: string) => api.post(`/contact-payments/${id}/void`, { reason }),
  get:            (id: number)   => api.get(`/sales/${id}`),
};
